export const GROUPS = 'GROUPS';
export const MASTER = 'MASTER';
